import React, { useContext, useEffect, useState } from 'react';
import moment from "moment"
import Select from 'react-select';

import { createBookingNoPay } from "../../../api/apiRequests";
import { UsersContext } from "../../../hooks/wrappers/UsersWrapper";
import useErrors from "../../../hooks/useErrors";
import useFormHandlers from "../../../hooks/useFormHandlers";


import { modelsConsWrapper } from "../../wrappers/modelsConsWrapper";

import FormPickUp from "./modify/FormPickUp";
import FormLeaveIt from "./modify/FormLeaveIt";
import Loading from "../../shared/wait/Loading";
import PieceOfInfo from "../../shared/PieceOfInfo";
import MySubmit from "../../shared/form/MySubmit";
import MyInput from "../../shared/form/MyInput";
import MyCheckBox from "../../shared/form/MyCheckBox";

const payMethods = [
  { label: "Pago con tarjeta Crédito / Debito", value: "card payment" },
  { label: "Transferencia Bancaria", value: "wire transfer" },
  { label: "Efectivo", value: "cash" },
  { label: "Gratis", value: "free" }
];

const ModalBooking = ({ booking, models, afterCreate, scooter, initDay, endDay, changeModal, rentals, isLoadingRentals }) => {
  const { users, isLoading: isLoadingUsers } = useContext(UsersContext)

  const { errors, captureErrors } = useErrors()

  const [data, setData] = useState({
    pickUp: booking ? { ...booking.pickUp } : {
      date: Date.parse(moment(initDay).hour(12).toDate()),
      delivery: false,
      adress: "",
      location: "",
      cp: "",
      phone: "",
      comments: ""
    },
    leaveIt: booking ? { ...booking.leaveIt } : {
      date: Date.parse(moment(endDay).hour(12).toDate()),
      delivery: false,
      samePlace: false,
      adress: "",
      location: "",
      cp: "",
      phone: "",
      comments: ""
    },
    selectedUser: null,
    selectedRental: null,
    payMethod: payMethods[0],
    calcAuto: true,
    price: 0,
  })
  const { pickUp, leaveIt, selectedUser, selectedRental, payMethod, calcAuto, price  } = data;
  const { handleInputChange } = useFormHandlers(setData)

  const [selectionUsers, setSelectionUsers] = useState(null)
  const [selectionRentals, setSelectionRentals] = useState(null)
  useEffect(() => {
    if(!rentals || !users) return

    const selectionUsers = [];
    const selectionRentals = [];
    let selectedUser = null;
    let selectedRental = null;
    users.forEach(user => {
      if (user.active) {
        const option = {
          value: user._id,
          label: (user.name + " " + user.surname + " - " + user.passport + " - " + user.email)
        };
        selectionUsers.push(option);
        if (booking) {
          if (user._id === booking.user._id) {
            selectedUser = option;
          }
        }
      }
    });

    Object.keys(models).forEach(key => {
      selectionRentals.push({ label: (models[key].name + " " + models[key].cubicCapacity), options: [] })
    });

    rentals.forEach(rental => {
      if (!rental.pause && rental.active === true) {
        const group = selectionRentals.filter(selec => selec.label === (rental.model.name + " " + rental.model.cubicCapacity))[0];
        const indexOfGroup = selectionRentals.indexOf(group);
        selectionRentals[indexOfGroup].options.push({ value: rental, label: rental.licensePlate });
        if (rental.licensePlate === scooter) {
          selectedRental = { value: rental, label: rental.licensePlate }
        }
      }
    });

    setSelectionUsers(selectionUsers)
    setSelectionRentals(selectionRentals)
    setData(data => ({...data, selectedRental, selectedUser}))
    // eslint-disable-next-line
  }, [rentals, users])


  useEffect(() => {
    checkSamePlace(data.leaveIt)
    // eslint-disable-next-line
  }, [leaveIt.samePlace])

  useEffect(() => {
    checkDeliveries(data)
    // eslint-disable-next-line
  }, [leaveIt.delivery])

  useEffect(() => {
    checkDeliveries(data)
    // eslint-disable-next-line
  }, [pickUp.delivery])

  const checkDeliveries = ({ pickUp, leaveIt }) => {
    !pickUp.delivery && setData(data => ({
      ...data,
      pickUp: {
        ...pickUp,
        adress: "",
        location: "",
        cp: "",
        phone: ""
      },
      leaveIt: {
        ...leaveIt,
        samePlace: false
      }
    }));

    !leaveIt.delivery && cleanSomeData("leaveIt", { ...leaveIt, samePlace: false });
  };

  const checkSamePlace = leaveIt =>
    leaveIt.samePlace && cleanSomeData("leaveIt", leaveIt);

  const cleanSomeData = (key, object) =>
    setData(data => ({
      ...data,
      [key]: {
        ...object,
        adress: "",
        location: "",
        cp: "",
        phone: ""
      }
    }))

  const setHourMinute = (instanceOfTime, hourAndMinute) => {
    const time = (Array.isArray(hourAndMinute) ? hourAndMinute : hourAndMinute.split(":", 2));
    return moment(instanceOfTime).hour(time[0]).minute(time[1]).toDate();
  };

  const changeInitDate = (initDate) => {
    if (initDate !== null) {
      const currInitDate = moment(pickUp.date);
      const newInitDate = setHourMinute(initDate, [currInitDate.hour(), currInitDate.minute()]);
      handleInputChange("pickUp.date", Date.parse(newInitDate));
    }
  };
  const changeEndDate = (endDate) => {
    if (endDate !== null) {
      const currEndDate = moment(leaveIt.date);
      const newEndDate = setHourMinute(endDate, [currEndDate.hour(), currEndDate.minute()]);
      handleInputChange("leaveIt.date", Date.parse(newEndDate));
    }
  };
  const changeInitHour = (initHourAndMinute) => {
    if (initHourAndMinute !== null) {
      const currInitDate = pickUp.date;
      const newInitDate = setHourMinute(currInitDate, initHourAndMinute);
      handleInputChange("pickUp.date", Date.parse(newInitDate));
    }
  };
  const changeEndHour = (endHourAndMinute) => {
    if (endHourAndMinute !== null) {
      const currEndDate = leaveIt.date;
      const newEndDate = setHourMinute(currEndDate, endHourAndMinute);
      handleInputChange("leaveIt.date", Date.parse(newEndDate));
    }
  };

  const changePayMethod = payMethod => {
    if(payMethod.value === "free")
      setData(data => ({ ...data, payMethod, calcAuto: false, price: 0 }))
    else
      handleInputChange('payMethod', payMethod)
  };

  const submit = (event) => {
    event.preventDefault();
    if (errors.length < 1 && selectedUser) {
      const days = Math.ceil(moment(leaveIt.date).diff(moment(pickUp.date), "days", true));
      createBookingNoPay(
        { ...pickUp, date: pickUp.date },
        { ...leaveIt, date: leaveIt.date },
        ((days > 0) ? days : 1),
        selectedUser.value,
        selectedRental.value._id,
        payMethod.value,
        (calcAuto ? null : parseFloat(price))
      )
        .then(() => {
          afterCreate();
          changeModal(null);
          alert("Se ha creado la reserva")
        })
        .catch(() => {
          alert("¡Ups! Parece que no existe disponibilidad. Prueba otras fechas.")
        })
    } else {
      alert("Todos los campos son obligatorios")
    }
  };

  return (
    <div className="bg-white p-5"
         style={{ minWidth: "300px", width: "90vw", maxWidth: "1500px", minHeight: "200px" }}>
      <form onSubmit={submit} className="row">
        <div className="col-12">
          <div className="row">
            <div className="col-12 col-lg-6">
              <PieceOfInfo title="CLIENTE" className="mr-lg-2"/>
              <div className="row mr-lg-2">
                {!isLoadingUsers && selectionUsers ? <Select
                  name="userSelect" required
                  value={selectedUser}
                  onChange={user => handleInputChange('selectedUser', user)}
                  options={selectionUsers}
                  className="rounded-0 w-100"
                /> : <Loading text="Cargando usuarios..." height="auto"/>}
              </div>
            </div>
            <div className="col-12 col-lg-6">
              <PieceOfInfo title="VESPA" className="ml-lg-2"/>
              <div className="row ml-lg-2">
                {!isLoadingRentals && selectionRentals ? <Select
                  name="modelSelect" required
                  value={selectedRental}
                  onChange={rental => handleInputChange('selectedRental', rental)}
                  options={selectionRentals}
                  className="rounded-0 w-100"
                /> : <Loading text="Cargando scooters..." height="auto"/>}
              </div>
            </div>
          </div>
        </div>
        <div className="col-12 mt-5">
          <div className="row">
            <div className="col-12 col-lg-6">
              <PieceOfInfo title="TIPO DE PAGO" className="mr-lg-2"/>
              <div className="row mr-lg-2 pt-1">
                <Select
                  name="paySelect"
                  value={payMethod}
                  onChange={changePayMethod}
                  options={payMethods}
                  className="rounded-0 w-100"
                />
              </div>
            </div>
            <div className="col-12 col-lg-6">
              <PieceOfInfo title="PRECIO" className="ml-lg-2"/>
              <div className="row">
                <div className="col-12 col-lg-6">
                  <div className="row form-check">
                    <MyCheckBox
                      title="Cálculo automático de precio"
                      name="delivery"
                      value={calcAuto}
                      onChange={event => handleInputChange('calcAuto', event.target.value)}
                      className="ml-1"
                    />
                  </div>
                </div>
                <div className="col-12 col-lg-6">
                  {!calcAuto &&
                    <MyInput
                      type="number"
                      propsInput={{ step: "any" }}
                      name="price"
                      value={price}
                      onChange={event => handleInputChange('price', event.target.value)}
                    />
                  }
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="col-12 mt-5">
          <FormPickUp
            changeDate={changeInitDate}
            changeHour={changeInitHour}
            info={pickUp}
            change={e => handleInputChange("pickUp."+e.target.name, e.target.value)}
            captureErrors={captureErrors}
          />
        </div>
        <div className="col-12 mt-5">
          <FormLeaveIt
            info={leaveIt}
            infoPickUp={pickUp}
            changeDate={changeEndDate}
            changeHour={changeEndHour}
            change={e => handleInputChange("leaveIt."+e.target.name, e.target.value)}
            captureErrors={captureErrors}
          />
        </div>
        <div className="col-12 col-md-6 col-lg-4 mt-3 offset-lg-8 offset-md-6">
          <div className="row">
            <MySubmit className="col bg-primary" text="CREAR"/>
          </div>
        </div>
      </form>
    </div>
  );
}

export default modelsConsWrapper(ModalBooking);
